import { gql, useMutation } from "@apollo/client";

import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { PushSubscriptionProvider } from "../constants";

interface UnregisterPushSubscriptionMutation {
  unregisterPushSubscription: {
    errors: Array<{ path: string; message: string }> | null;
    message: string | null;
  };
}

interface UnregisterPushSubscriptionVariables {
  provider: PushSubscriptionProvider;
  token: string;
}

export const unregisterPushSubscriptionMutation = gql`
  mutation UnregisterPushSubscriptionMutation($provider: String!, $token: String!) {
    unregisterPushSubscription(provider: $provider, token: $token) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export function useUnregisterPushSubscription() {
  const [mutate, { loading, error, data }] = useMutation<
    UnregisterPushSubscriptionMutation,
    UnregisterPushSubscriptionVariables
  >(unregisterPushSubscriptionMutation);

  const unregisterPushSubscription = async (provider: PushSubscriptionProvider, token: string) => {
    const { data: mutationData } = await mutate({
      variables: { provider, token },
    });

    const result = mutationData?.unregisterPushSubscription;
    const errors = result?.errors ? normalizeErrors(result.errors) : null;

    return {
      errors: errors as NormalizedErrorMap | null,
      message: result?.message ?? undefined,
    };
  };

  return {
    unregisterPushSubscription,
    loading,
    error,
    message: data?.unregisterPushSubscription?.message || null,
  };
}